import { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { apiClient, ApiError } from "../api/client";
import { ErrorState, LoadingState } from "../components/AsyncState";

export function LegacyProjectRedirect({ upload = false }: { upload?: boolean }) {
  const { projectId = "" } = useParams();
  return <ResolvedRedirect cacheKey={`project:${projectId}:${upload}`} resolve={async () => {
    const project = await apiClient.getProject(projectId);
    return `/organizations/${project.organization_id}/projects/${project.id}${upload ? "/upload" : ""}`;
  }} />;
}

export function LegacyTaskRedirect() {
  const { taskId = "" } = useParams();
  return <ResolvedRedirect cacheKey={`task:${taskId}`} resolve={async () => {
    const task = await apiClient.getTask(taskId);
    const project = await apiClient.getProject(task.project_id);
    return `/organizations/${project.organization_id}/tasks/${task.id}`;
  }} />;
}

export function LegacyJobRedirect() {
  const { jobId = "" } = useParams();
  return <ResolvedRedirect cacheKey={`job:${jobId}`} resolve={async () => {
    const job = await apiClient.getJob(jobId);
    const project = await apiClient.getProject(job.project_id);
    return `/organizations/${project.organization_id}/jobs/${job.id}`;
  }} />;
}

export function LegacySessionRedirect() {
  const { sessionId = "" } = useParams();
  return <ResolvedRedirect cacheKey={`session:${sessionId}`} resolve={async () => {
    const scope = await apiClient.getSessionScope(sessionId);
    return `/organizations/${scope.organization_id}/projects/${scope.project_id}/sessions/${sessionId}`;
  }} />;
}

function ResolvedRedirect({ cacheKey, resolve }: { cacheKey: string; resolve: () => Promise<string> }) {
  const [target, setTarget] = useState("");
  const [error, setError] = useState("");
  useEffect(() => {
    let cancelled = false;
    void resolve().then((value) => { if (!cancelled) setTarget(value); }).catch((reason) => {
      if (!cancelled) setError(reason instanceof ApiError ? reason.message : "旧链接无法解析");
    });
    return () => { cancelled = true; };
  }, [cacheKey]);
  if (error) return <ErrorState message={error} />;
  return target ? <Navigate to={target} replace /> : <LoadingState label="正在打开组织工作区…" />;
}
